import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./About.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>
                        <span>About</span> Serene
                    </h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h5>Who we are</h5>{" "}
                        <h3>
                            At <b>Serene Tax</b>, we specialize in accounting
                            and tax preparation services for a diverse range of
                            clients
                        </h3>
                        <p>
                            We are a respected CPA firm dedicated to helping our
                            clients navigate the complex rules of U.S. tax
                            filing. Our primary goal is to make the tax filing
                            process as simple and stress-free as possible for
                            every client. We provide ongoing support and
                            expertise in tax planning and preparation.
                            <br />
                            We assist many Indian corporations and individuals
                            who face intricate challenges in understanding the
                            United States tax system. Our U.S. Tax Specialized
                            Group helps corporations and individuals safely
                            navigate these complexities. We ensure compliance
                            with all necessary corporate and personal income tax
                            requirements for Indians working in the U.S. under
                            visas such as H1B, L1, and B1, as well as those
                            visiting for educational purposes under OPT and CPT.
                            One of our key priorities is maintaining consistent
                            communication with our clients and offering extended
                            business hours. We go above and beyond to meet
                            client needs, treating them like an extended family.
                            <br />
                            Our firm has been built on the foundation of
                            resolving what once seemed impossible. This success
                            stems from our extraordinary team, who set ambitious
                            goals and achieve remarkable breakthroughs. Serene
                            Tax is proud to be one of the few Service Certifying
                            Acceptance Agents recognized by the United States
                            Internal Revenue Service (IRS).
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>
                            We specialize in accounting and tax preparation
                            services for a wide array of clients.
                        </h3>
                        <ul>
                            <li>
                                Our objective is to help our clients maintain
                                financial viability in the present, while taking
                                a proactive approach to achieve all their future
                                goals
                            </li>
                            <li>
                                Dedication — We believe this to be a direct
                                derivative of our talent and responsiveness to
                                our client base.
                            </li>
                            <li>
                                Providing services that not only meet but exceed
                                your expectations
                            </li>
                            <li>
                                Use of the most current technology available in
                                the accounting industry
                            </li>
                            <li>
                                Communication, both with you and within our firm
                            </li>
                            <li>
                                Constant evaluation of our processes and
                                performance
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h5>What we Do</h5>{" "}
                        <h3 style={{ fontSize: "1.5rem" }}>Our Objective</h3>
                        <p>
                            Our objective is to help our clients maintain
                            financial viability in the present while taking a
                            proactive approach to achieve all their future
                            goals. This requires open communication to fully
                            understand our clients' needs through research and
                            sound analysis. Serene Tax is committed to meeting
                            these goals with high standards of excellence.
                        </p>
                        <h3 style={{ fontSize: "1.5rem" }}>Dedication</h3>
                        <p>
                            We believe that dedication is a direct result of our
                            talent and responsiveness to our client base.
                            Whether you are a current or prospective client,
                            rest assured that individuals and businesses who
                            choose our services receive competent and timely
                            advice.
                        </p>
                        <h3 style={{ fontSize: "1.5rem" }}>
                            Exceeding Expectations
                        </h3>
                        <p>
                            We provide services that not only meet but exceed
                            your expectations.
                        </p>
                        <h3 style={{ fontSize: "1.5rem" }}>
                            Cutting-Edge Technology
                        </h3>
                        <p>
                            We use the most current technology available in the
                            accounting industry.
                        </p>
                        <h3 style={{ fontSize: "1.5rem" }}>Communication</h3>
                        <p>
                            We prioritize communication, both with you and
                            within our firm.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3 style={{ fontSize: "1.5rem" }}>
                            Continuous Improvement
                        </h3>
                        <p>
                            We constantly evaluate our processes and
                            performance.
                        </p>
                        We guide our clients through a full range of tax
                        planning and preparation decisions with strategies that
                        minimize tax liabilities, maximize cash flow, and keep
                        them on track to achieve their financial goals. Our
                        expertise, experience, analysis, and thorough research
                        allow us to optimize financial opportunities presented
                        by both existing and recently amended tax laws. We stay
                        knowledgeable and up-to-date on tax laws, and we can
                        make sense of your receipts, bills, and notices.
                        <h3>Our Mission</h3>
                        <p>
                            Our mission remains the same: to provide each small
                            business and individual client with the right
                            personal attention and detail
                        </p>
                    </div>
                </div>
            </div>
            {/* <AboutCard /> */}
        </Layout>
    );
}

export default About;
